import React, { useState, useEffect, useRef } from 'react';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { useTranslation } from 'react-i18next';


import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import EventBus from "../../common/EventBus";
import { Toast } from 'primereact/toast';
import AuthService from '../../security/AuthService';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import AccountService from '../../service/AccountService';
import utils from '../../constants/utils';

export const WaitList = (props) => {


    const { t } = useTranslation();
    const toast = useRef(null);
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);
    const [filters, setFilters] = useState(null);

    const [status, setStatus] = useState(0);

    const [waitList, setWaitList] = useState([]);

    const [selectedWaitList, setSelectedWaitList] = useState([]);
    const [loadingWaitList, setLoadingWaitList] = useState(true);

    useEffect(() => {
        onLoadData();
    }, []);


    const onLoadData = () => {
        setDisplayLoadingDialog(true);
        setWaitList([]);
        AccountService.inquirewaitlistbystatus(status).then(
            (response) => {
                console.log("inquirewaitlistbystatus", response)
                console.log("inquirewaitlistbystatus", response.data.data.dataList)
                if (response.data.data.dataList.length > 0) {
                    console.log("set inquirewaitlistbystatus", response.data.data.dataList)
                    setWaitList(response.data.data.dataList);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquirewaitlistbystatus logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }



    const exportToExcel = () => {
        console.log("exportexcel", waitList);

        if (waitList != null) {
            import('xlsx').then(xlsx => {
                const worksheet = xlsx.utils.json_to_sheet(waitList);
                const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                saveAsExcelFile(excelBuffer, 'Wait List');
            });
        }
    }


    const saveAsExcelFile = (buffer, fileName) => {

        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });

    }

    const onUpdateWaitListStatus = (_selectedWaitList, newStatus) => {


        const apiParams = { id: _selectedWaitList.id, email: _selectedWaitList.email, status: newStatus };
        if (_selectedWaitList) {


            AccountService.updateWaitList(apiParams).then(
                (response) => {
                    console.log("updateWaitListStatus", response)
                    onLoadData();
                },
                (error) => {
                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        } else {
            console.log("Select Waitlist");
        }

    }


    const leftToolbarTemplate = () => {
        return (
            <h5>{t('global_text_wait_list')}</h5>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button type="button" icon="pi pi-file-excel" onClick={exportToExcel} className="mr-2" title={t('export_to_excel')} />
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-check" className="p-button-rounded p-button-success p-button-outlined mr-2 mb-2" onClick={() => onUpdateWaitListStatus(rowData, 1)} />
                <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-outlined mr-2 mb-2" onClick={() => onUpdateWaitListStatus(rowData, - 1)} />
            </React.Fragment>
        );
    }


    const statusBodyTemplate = (data) => {
        return (
            <>
                <div>
                    <span style={
                        { color: data?.status === 0 ? '#000000' : data?.status === 1 ? '#0BD18A' : '#FC6161' }}>{t('global_text_status_' + data?.status)}</span>
                </div>


            </>
        )
    };

    const dateTemplate = (rowData) => {
        return utils.formatDateTime(new Date(rowData.cdate));
    }

    return (
        <div className="layout-dashboard">

            <div className="grid">
                <Toast ref={toast} />

                <div className="col-12">
                    <div className="card">
                        <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>

                        <DataTable value={waitList} paginator className="p-datatable-customers" showGridlines rows={10}
                            dataKey="id" filters={filters} filterDisplay="menu" loading={displayLoadingDialog}
                            emptyMessage={t('global_text_no_found')} rowHover selection={selectedWaitList}
                            onSelectionChange={e => setSelectedWaitList(e.value)}  >

                            <Column field="email" header={t('global_text_email')} filter filterPlaceholder={t('global_text_email')} style={{ minWidth: '12rem' }} />

                            <Column field="cdate" header={t('global_text_cdate')} filter filterPlaceholder={t('global_text_cdate')} body={dateTemplate} />
                            <Column field="status" header={t('global_text_status')} filter body={statusBodyTemplate} />
                            <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>


                        </DataTable>
                    </div>
                </div>

            </div>
        </div>
    )
}